import { apiClient } from '../api';

export async function importAssets(rows) {
  const res = await apiClient.post('/api/import', { rows });
  return res.data;
}
